import { FieldValues } from 'react-hook-form';

export type DirtyFieldsType = boolean | null | { [key: string]: DirtyFieldsType } | DirtyFieldsType[];

// Taken from https://github.com/orgs/react-hook-form/discussions/1991#discussioncomment-13040877
export function getDirtyValues<T extends FieldValues>(
  dirtyFields: Partial<Record<keyof T, DirtyFieldsType>>,
  values: T,
): Partial<T> {
  const dirtyValues = Object.keys(dirtyFields).reduce((prev, key) => {
    const value = dirtyFields[key];
    if (!value) {
      return prev;
    }
    const isObject = typeof value === 'object';
    const isArray = Array.isArray(value);
    const nestedValue = isObject && !isArray ? getDirtyValues(value, values[key]) : values[key];
    return { ...prev, [key]: isArray ? values[key] : nestedValue };
  }, {} as Partial<T>);
  return dirtyValues;
}
